import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AddLocationComp from "./Component/AddLocationComp"


const AddLocation =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <AddLocationComp />
        </div>
        <Footer />
        </>
    )
}

export default AddLocation